// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RFYshYVbUCRSrPxo {
  min-height: calc(100vh - 97px);
  background-color: #f3f5f7;
  border-radius: 0 26px 26px 0;
  width: 315px;
  box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
  padding: 51px 0 0 26px;
  flex-shrink: 0;
  margin-top: 97px;
  position: fixed;
  left: 0;
  top: 0;
  display: block
}

.RFYshYVbUCRSrPxo h2 {
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  color: #303030;
  margin: 0 0 38px;
}

.RFYshYVbUCRSrPxo i::before {
  display: inline-block;
  height: 25px;
  width: 25px;
  font-size: 25px;
}

.RFYshYVbUCRSrPxo i {
  margin-right: 12px;
}

.RFYshYVbUCRSrPxo li {
  margin-right: 25px;
}

.RFYshYVbUCRSrPxo li a {
  background-color: #ffffff;
  margin-bottom: 18px;
  border-radius: 16px;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 600;
  color: #303030;
  padding: 25px;
}

.RFYshYVbUCRSrPxo li a:hover {
  background-color: #e1e7ed;
}

li.zYViWnClQANv3KRQ {
  margin-right: 0;
}

.RFYshYVbUCRSrPxo li a.zYViWnClQANv3KRQ {
  border-radius: 16px 0 0 16px;
  color: #ffffff;
  background-color: #20336c;
}

a.zYViWnClQANv3KRQ i {
  margin-right: 30px;
}

.Y3PvTFmkIfIBXV83 {
  width: 100%;
  background-color: #4D87BE;
  border-radius: 16px;
  padding: 18px 20px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  border: none;
}

.Y3PvTFmkIfIBXV83:hover {
  background-color: #20336C;
}

.GdWVWMOkcLU9fpwe {
  width: 100%;
  background-color: #F3F5F7;
  border-radius: 16px;
  padding: 10px 20px;
  color: #4D87BE;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.GdWVWMOkcLU9fpwe:hover {
  color: #305375;
}

.puEQgj2Z4lsFAVTV {
  width: 541px !important;
  height: 354px !important;
  background-color: #F3F5F7;
  border-radius: 25px !important;
}

.puEQgj2Z4lsFAVTV .p-dialog {
  border-radius: 25px !important;
  background-color: #F3F5F7;
}

.puEQgj2Z4lsFAVTV .p-dialog-footer {
  border-bottom-right-radius: 25px !important;
  border-bottom-left-radius: 25px !important;
  background-color: #F3F5F7;
}

.puEQgj2Z4lsFAVTV .p-dialog-header {
  border-top-right-radius: 25px !important;
  border-top-left-radius: 25px !important;
  background-color: #F3F5F7;
}

.puEQgj2Z4lsFAVTV .p-dialog-content{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.puEQgj2Z4lsFAVTV .zjV_kxxOE6O8wCdc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
}

.puEQgj2Z4lsFAVTV .p-dialog-content {
  background-color: #F3F5F7;
}

.puEQgj2Z4lsFAVTV .p-dialog-title {
  font-size: 1.875rem !important;
  font-weight: 700 !important;
}

@media screen and (max-width: 1280px) {
  .RFYshYVbUCRSrPxo {
    margin-top: 65px;
    min-height: calc(100vh - 65px);
  }
}

@media screen and (max-width: 1104px) {
  .RFYshYVbUCRSrPxo {
    margin-top: 65px;
    min-height: calc(100vh - 65px);
    width: 0;
  }
}

@media screen and (max-width: 768px) {
  .RFYshYVbUCRSrPxo {
    display: none;
    width: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SidebarMenu.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,6CAA6C;EAC7C,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,MAAM;EACN;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;IAChB,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;IACb,QAAQ;EACV;AACF","sourcesContent":[".sidebar {\r\n  min-height: calc(100vh - 97px);\r\n  background-color: #f3f5f7;\r\n  border-radius: 0 26px 26px 0;\r\n  width: 315px;\r\n  box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);\r\n  padding: 51px 0 0 26px;\r\n  flex-shrink: 0;\r\n  margin-top: 97px;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  display: block\r\n}\r\n\r\n.sidebar h2 {\r\n  font-family: Roboto;\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n  color: #303030;\r\n  margin: 0 0 38px;\r\n}\r\n\r\n.sidebar i::before {\r\n  display: inline-block;\r\n  height: 25px;\r\n  width: 25px;\r\n  font-size: 25px;\r\n}\r\n\r\n.sidebar i {\r\n  margin-right: 12px;\r\n}\r\n\r\n.sidebar li {\r\n  margin-right: 25px;\r\n}\r\n\r\n.sidebar li a {\r\n  background-color: #ffffff;\r\n  margin-bottom: 18px;\r\n  border-radius: 16px;\r\n  font-family: Roboto;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #303030;\r\n  padding: 25px;\r\n}\r\n\r\n.sidebar li a:hover {\r\n  background-color: #e1e7ed;\r\n}\r\n\r\nli.active {\r\n  margin-right: 0;\r\n}\r\n\r\n.sidebar li a.active {\r\n  border-radius: 16px 0 0 16px;\r\n  color: #ffffff;\r\n  background-color: #20336c;\r\n}\r\n\r\na.active i {\r\n  margin-right: 30px;\r\n}\r\n\r\n.confirmDialogBtn {\r\n  width: 100%;\r\n  background-color: #4D87BE;\r\n  border-radius: 16px;\r\n  padding: 18px 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #ffffff;\r\n  border: none;\r\n}\r\n\r\n.confirmDialogBtn:hover {\r\n  background-color: #20336C;\r\n}\r\n\r\n.cancelDialogBtn {\r\n  width: 100%;\r\n  background-color: #F3F5F7;\r\n  border-radius: 16px;\r\n  padding: 10px 20px;\r\n  color: #4D87BE;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  border: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n  color: #305375;\r\n}\r\n\r\n.alertModal {\r\n  width: 541px !important;\r\n  height: 354px !important;\r\n  background-color: #F3F5F7;\r\n  border-radius: 25px !important;\r\n}\r\n\r\n.alertModal :global(.p-dialog) {\r\n  border-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-footer) {\r\n  border-bottom-right-radius: 25px !important;\r\n  border-bottom-left-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-header) {\r\n  border-top-right-radius: 25px !important;\r\n  border-top-left-radius: 25px !important;\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-content){\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.alertModal .text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 400;\r\n}\r\n\r\n.alertModal :global(.p-dialog-content) {\r\n  background-color: #F3F5F7;\r\n}\r\n\r\n.alertModal :global(.p-dialog-title) {\r\n  font-size: 1.875rem !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .sidebar {\r\n    margin-top: 65px;\r\n    min-height: calc(100vh - 65px);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1104px) {\r\n  .sidebar {\r\n    margin-top: 65px;\r\n    min-height: calc(100vh - 65px);\r\n    width: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .sidebar {\r\n    display: none;\r\n    width: 0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var sidebar = `RFYshYVbUCRSrPxo`;
export var active = `zYViWnClQANv3KRQ`;
export var confirmDialogBtn = `Y3PvTFmkIfIBXV83`;
export var cancelDialogBtn = `GdWVWMOkcLU9fpwe`;
export var alertModal = `puEQgj2Z4lsFAVTV`;
export var text = `zjV_kxxOE6O8wCdc`;
export default ___CSS_LOADER_EXPORT___;
